import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { IProducto } from "src/app/interfaces/IProducto";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AcordarService {
  constructor(private http: HttpClient) {}

  //Mapa Solicitudes de oferta

  getProvinciasConOfertas(): Observable<any> {
    let params = {};
    return this.http
      .get<Array<any>>(`${environment.apiUrl}/ofertas/solicitudes/provincias`, {
        params,
      })
      .pipe(catchError((error) => throwError(error)));
  }

  //Mapa Ofertas de productos

  getOfertasProductos(): Observable<any> {
    let params = {};
    return this.http
      .get<Array<any>>(`${environment.apiUrl}/ofertas/provincias`, { params })
      .pipe(catchError((error) => throwError(error)));
  }

  getProductoPorNumCat(num_cat, page, filtros = null): Observable<any> {
    let params = {
      "producto.codigo_catalogo": num_cat,
      page: page,
      size: "100",
      order_by: "+inhabilitado|+producto.marca|-fecha",
    };
    if (filtros !== null) {
      filtros.map((filtro) => {
        params[filtro.nombre] = filtro.value;
      });
    }

    return this.http
      .get<Array<any>>(`${environment.apiUrl}` + "/ofertas/", { params })
      .pipe(catchError((error) => throwError(error)));
  }

  //filtros

  getBuscarSolicitud(page, filtros = null): Observable<any> {
    let params = {
      page: page,
      size: "5",
      order_by: "-fecha",
    };
    if (filtros !== null) {
      filtros.map((filtro) => {
        params[filtro.nombre] = filtro.value;
      });
    }
    return this.http
      .get<Array<any>>(`${environment.apiUrl}/ofertas/solicitudes/`, { params })
      .pipe(catchError((error) => throwError(error)));
  }

  getBuscarContrataciones(page, filtros = null): Observable<any> {
    let params = {
      page: page,
      size: "1",
      order_by: "-fecha",
    };
    if (filtros !== null) {
      filtros.map((filtro) => {
        params[filtro.nombre] = filtro.value;
      });
    }
    return this.http
      .get<Array<IProducto>>(`${environment.apiUrl}/contrataciones/`, {
        params,
      })
      .pipe(catchError((error) => throwError(error)));
  }

  getBuscarOfertas(page, filtros): Observable<any> {
    let params = {
      page: page,
      size: "1",
    };
    if (filtros !== null) {
      filtros.map((filtro) => {
        params[filtro.nombre] = filtro.value;
      });
    }
    return this.http
      .get<Array<any>>(`${environment.apiUrl}/ofertas` + "/codigos_catalogos", {
        params,
      })
      .pipe(catchError((error) => throwError(error)));
  }
}
